import { Component } from '@angular/core';
import { FormProperty } from '../angular2-schema-form-shim';
import { SchemaButtonGroup, SchemaButton } from '../types/json-schema';
import { ObjectProperty } from '../formproperty';

@Component( {
  selector: 'sp-buttongroup-widget',
  templateUrl: './buttongroup.widget.html',
} )
export class ButtonGroupWidget {
  public button: SchemaButtonGroup & { action: () => void };
  public formProperty: FormProperty;

  get buttons() {
    return this.button.buttons;
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/buttongroup.widget.ts